import { gql } from '../../../../../hooks'

export const DELETE_TYPES = gql`
  mutation AdministrationDeleteMachineTypes($id: ID!) {
    aDelete(path: "machine/types", id: $id) {
    }
  }
`

export const LIST_TYPES = gql`
  query AdministrationListMachineTypes(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(path: "machine/types", filter: $filter, page: $page, limit: $limit) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
